import { Form, SelectBox } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { container, containerTall } from 'styles/layout';
import { headingLower, legal } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Container = styled.div`
  ${container}

  margin: 24px auto 0;
  text-align: left;
`;

export const Subhead = styled.h2`
  ${headingLower}

  margin: 0 0 11px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const PreferredTimeContainer = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.3);
  margin: 24px 0 0;
  padding: 23px 0 0;
`;

export const TimeSelectBox = styled(SelectBox)`
  svg {
    height: 25px;
    width: 25px;
  }

  ${({ theme }: IWithThemeProps) => `
    [data-svg-class="Clock-stroke"] {
      stroke: ${theme.svgStrokeDefault};
    }
  `}
`;

export const Description = styled.p`
  ${legal}

  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;
